// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.busy-indicator {
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  animation: 600ms fadeIn;
  animation-fill-mode: forwards;
  opacity: 0;
}

.busy-indicator__big {
  height: 6rem;
}

.busy-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.busy-container__lock-ui {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding-top: 2rem;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 2;
}

.busy-container__overlaid {
  position: absolute;
  top: max(5px, calc(50% - 20px));
  left: calc(50% - 20px);
  z-index: 3;
  width: 40px;
  height: 40px;
}

.busy-container__overlaid.busy-indicator__show-on-top {
  top: 5px;
}

.busy-container__overlaid:not(.busy-indicator__show-on-top) {
  max-height: 100vh;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/controls/BusyIndicator/BusyIndicator.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;EAEvB,uBAAuB;EACvB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".busy-indicator {\r\n  display: flex;\r\n  flex: 0 1 auto;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  animation: 600ms fadeIn;\r\n  animation-fill-mode: forwards;\r\n  opacity: 0;\r\n}\r\n\r\n.busy-indicator__big {\r\n  height: 6rem;\r\n}\r\n\r\n.busy-container {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.busy-container__lock-ui {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  padding-top: 2rem;\r\n  background-color: rgba(255, 255, 255, 0.7);\r\n  z-index: 2;\r\n}\r\n\r\n.busy-container__overlaid {\r\n  position: absolute;\r\n  top: max(5px, calc(50% - 20px));\r\n  left: calc(50% - 20px);\r\n  z-index: 3;\r\n  width: 40px;\r\n  height: 40px;\r\n}\r\n\r\n.busy-container__overlaid.busy-indicator__show-on-top {\r\n  top: 5px;\r\n}\r\n\r\n.busy-container__overlaid:not(.busy-indicator__show-on-top) {\r\n  max-height: 100vh;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  50% {\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
